import React from 'react';
import HeroSection from './Components/Home2026/HeroSection';
import StatsBand from './Components/Home2026/StatsBand';
import ToolkitMarquee from './Components/Home2026/ToolkitMarquee';
import RoleSection from './Components/Home2026/RoleSection';
import PlatformSection from './Components/Home2026/PlatformSection';
import PricingSection from './Components/Home2026/PricingSection';
import FieldSection from './Components/Home2026/FieldSection';
import FieldFirstSection from './Components/Home2026/FieldFirstSection';
import CompetitorSection from './Components/Home2026/CompetitorSection';
import LoopFamilySection from './Components/Home2026/LoopFamilySection';
import OutcomesSection from './Components/Home2026/OutcomesSection';
import FaqSection from './Components/Home2026/FaqSection';
import FinalCtaSection from './Components/Home2026/FinalCtaSection';

// Homepage — 2026 redesign. Structure: hero → dark stats band → toolkit
// marquee → roles → numbered platform chapters (01 platform, 02 pricing,
// 03 field-first, 04 competitor comparison) with the phone showcase between
// → Loop family → outcomes → FAQ → dark finale.
export default function Website() {
  return (
    <>
      <HeroSection />
      <StatsBand />
      <ToolkitMarquee />
      <RoleSection />
      <PlatformSection />
      <PricingSection />
      <FieldSection />
      <FieldFirstSection />
      <CompetitorSection />
      <LoopFamilySection />
      <OutcomesSection />
      <FaqSection />
      <FinalCtaSection />
    </>
  );
}
